const trackingTranslation = {
  mode: 'en',
  menu: 'Settlement Management',

  babymagicsMenu: 'BabyView AI Settlement',
  barcodesMenu: 'Barcode Settlement',
  plansMenu: 'Plan Management',

  babymagicOrders: 'Order History',
  babymagicRefunds: 'Refund History',
  barcodeOrders: 'Barcode Orders',
  barcodeRefunds: 'Barcode Refunds',
  settlements: 'Monthly Settlement',
  planDefinition: 'Plan Definition',
  hospitalContracts: 'Hospital Contract Review',

  // refunds
  refundOrder: 'Process Refund',
  babyMagicRefundProcessing: 'BabyView AI Refund Processing',
  barcodeRefundProcessing: 'Barcode Refund Processing',
  pleaseEnterRefundReason: 'Please enter refund reason',
  enterRefundReason: 'Enter refund reason',
  processRefund: 'Process Refund',

  // For table
  index: 'No.',
  orderNumber: 'Order Number',
  refundNumber: 'Refund Number',
  barcodeNumber: 'Barcode Number',
  hospitalName: 'Hospital Name',
  planName: 'Plan Name',
  planType: 'Service Type',
  billingMethod: 'Billing Method',
  unitPrice: 'Unit Price',
  monthlyPrice: 'Monthly Fee',
  description: 'Description',
  orderStatus: 'Order Status',
  createdAt: 'Created At',
  refundedAt: 'Refunded At',
  refundReason: 'Refund Reason',
  refundedReason: 'Refund Reason',
  appliedPlan: 'Applied Plan',
  appliedPlanTooltip: 'You can check the applied plan information',

  // Order status
  complete: 'Order Complete',
  refunded: 'Refund Complete',

  // Refund reasons
  customerComplaint: 'Customer Complaint',
  serviceError: 'Service Error',
  other: 'Other',
  refundReasonPlaceholder: 'Enter refund reason',

  // Plan tooltip
  type: 'Type',
  babyMagic: 'BabyView AI',
  barcode: 'Barcode',
  price: '{{price}}{{unit}}',
  KRW: 'KRW',
  USD: 'USD',
  VND: 'VND',
  IDR: 'IDR',
  MXN: 'MXN',

  // Billing methods
  perCase: 'Per Case',
  monthlyFixed: 'Monthly Fixed',
  perCaseAndMonthly: 'Per Case + Monthly',

  // Search and filter
  hospitalSearch: 'Hospital Search',
  yearSelect: 'Select Year',
  yearSelectPlaceholder: 'Select a year',
  planNamePlaceholder: 'Enter plan name',
  startDate: 'Start Date',
  endDate: 'End Date',
  csvDownload: 'CSV Download',
  hospitalSearchPlaceholder: 'Enter hospital name',
  barcodeNumberPlaceholder: 'Barcode Search',
  orderNumberPlaceholder: 'Order Number Search',
  dateRange: 'Date Range',
  startDatePlaceholder: 'Start Date',
  endDatePlaceholder: 'End Date',
  today: 'Today',
  oneWeek: '1 Week',
  oneMonth: '1 Month',
  threeMonths: '3 Months',

  // Plan registration modal
  addPlan: 'New Plan Registration',
  pleaseEnterPlanName: 'Please enter plan name',
  max20Characters: 'Max 20 characters',
  enterPlanName: 'Enter plan name',
  enterNumbersOnly: 'Please enter numbers only',
  atLeastOneFeeRequired: 'At least one of per-case fee or monthly fee is required.',
  enterPlanDescription: 'Enter plan description',
  cancel: 'Cancel',
  register: 'Register',

  // Hospital plan management
  addHospitalPlan: 'New Hospital Contract Registration',
  pleaseSelectPlanType: 'Please select plan type',
  feeByCase: 'Fee by Case',
  feeMonthly: 'Monthly Fee',

  // Hospital plan modal
  newHospitalContractRegistration: 'New Hospital Contract Registration',

  // Settlement management
  yearMonth: 'Year-Month',
  generatedCount: 'Generated Count',
  refundCount: 'Refund Count',
  validCount: 'Valid Count',
  settlementAmount: 'Settlement Amount',
  adjustmentAmount: 'Adjustment Amount',
  adjustmentReason: 'Adjustment Reason',
  adjustmentCount: 'Hospital Count',
  finalSettlementAmount: 'Final Settlement Amount',
  settlementStatus: 'Settlement Status',
  confirmed: 'Confirmed',
  unconfirmed: 'Unsettled',
  enterAdjustmentReason: 'Enter adjustment reason',
  selectHospital: 'Select Hospital',
  pleaseSelectHospital: 'Please select a hospital',
  selectPlan: 'Select Plan',
  pleaseSelectPlan: 'Please select a plan',
  applicationPeriod: 'Application Period',
  pleaseSelectApplicationPeriod: 'Please select application period',
  endDateOptional: 'End Date (Optional)',
  contractTerminationInfo:
    'Existing contracts of the same hospital and service type will be automatically terminated upon registration.',
  count: '{{count}} items',
  totalCount: 'Total {{count}} items',
  viewDetail: 'View Details',
  confirm: 'Confirm',
  confirmSettlement: 'Do you want to confirm the settlement?',
  confirmCancelSettlement: 'Do you want to revert to unsettled status?',
  revert: 'Revert',
  image: 'Image',
  viewImage: 'View Image',

  // End date management
  changeContractEndDate: 'Do you want to change the contract end date?',
  setContractEndDate: 'Do you want to set the contract end date?',
  change: 'Change',
  set: 'Set',
  selectEndDate: 'Select End Date',

  // Success messages
  REQUEST_SUCCESS: 'Request completed successfully.',

  // Error messages
  UNKNOWN_ERROR: 'An unknown error occurred. Please try again later.',
  PLAN_NAME_ALREADY_EXISTS: 'A plan with this name already exists.',
  PLAN_TYPE_NOT_FOUND_FOR_PLAN_SEQ: 'Plan not found.',
  ORDER_NOT_FOUND_FOR_ORDER_SEQ: 'Order not found.',
};

export default trackingTranslation;
